import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import QRCode from '../QRCode'
import EmailReceipt from './EmailReceipt'
import EmailReceiptModal from './EmailReceiptModal'
import { PRINTING_ENABLED } from '../../constants'
import { ReactComponent as PrintRecieptIcon } from '../../assets/icons/print-receipt-icon.svg';
import { ReactComponent as SendEmailIcon } from '../../assets/icons/send-email-icon.svg';

import styles from './QRCodeReceipt.module.scss'
import { centsToDollars } from '../../utils/formatters'

const QRCodeReceipt = ({ onDone, order, qrCodeData, printOrder, className, sendEmails, paymentId, hasBalanceDueInCents, balanceDueDisplay, isNewOrder, available }) => {
  const [isEmailClicked, setIsEmailClicked ] = useState(false)
  const [isOnline, setIsOnline] = useState(true)

  useEffect(() => {
    setIsOnline(available);
    window.addEventListener("offline", event => setIsOnline(event.type === "online"))
    window.addEventListener("online", event => setIsOnline(event.type === "online"))
    return () => {
      window.removeEventListener('online', event => setIsOnline(event.type === "online"))
      window.removeEventListener('offline', event => setIsOnline(event.type === "online"))
    }
  }, [])

  const [showSendEmailReceiptModal, setSendEmailReceiptModal] = useState(false)
  const classNames = cn(styles.qrCodeReceipt, className)
  const mediaQuery = window.matchMedia("(max-width: 450px)")

  let nextText = "I'm Done" 

  if (hasBalanceDueInCents) {
    nextText = "Continue to next tender"
  }
    
  const payments = order?.createOrderParams?.payments ?? []

  const printReceipt = () => {
    printOrder({
      deviceType: 'concessions',
      orderUuid: order?.uuid,
      isNewOrder,
    })
  }

  let footerTextElement
  if (order.remainingTicketBalance !== undefined) {
    footerTextElement = <div className={styles.balanceDue}> {`Remaining Ticket Balance: ${centsToDollars(order.remainingTicketBalance)}`}</div>
  } else
  if (paymentId && !order.submittedAt) {
    footerTextElement = <div className={styles.balanceDue}> {`Balance Due: ${balanceDueDisplay}`}</div>
  } 

  let sendEmailModal = null
  const handleSendEmailClick = () => {
    setSendEmailReceiptModal(true)
  }

  if(showSendEmailReceiptModal) {
    sendEmailModal = (
      <EmailReceiptModal onClose={() => setSendEmailReceiptModal(false)} order={order} sendEmails={sendEmails} paymentId={paymentId} />
    )
  }
  
  return (
    <div className={classNames}>
      <div>
        {false && <QRCode data={qrCodeData} className={styles.qrCode} />}
        <div className={styles.qrFooter}>
          {!(payments[0]?.paymentType === "mobile_pay") && (!hasBalanceDueInCents) && isOnline &&
            <div className={styles.emailContainer}>
              {isEmailClicked ?
                <EmailReceipt
                  order={order}
                  sendEmails={sendEmails}
                  paymentId={paymentId}
                  /> : <button
                  className={styles.emailReceiptButton}
                  onClick={handleSendEmailClick}
                  title='Email Receipt'
                >
                  <SendEmailIcon /> Email Receipt
                </button>
              }
              {sendEmailModal}
            </div>}
            {PRINTING_ENABLED && !hasBalanceDueInCents && (
          <div>
            <button
              className={styles.printReceiptButton}
              onClick={printReceipt}
              title='Print Receipt'
            >
              <PrintRecieptIcon />Print Receipt
            </button>
          </div>
        )}
        {(!mediaQuery?.matches || (paymentId && !order.submittedAt)) && 
          <button
            className={styles.doneButton}
            onClick={() => onDone(hasBalanceDueInCents)}
          >
            {nextText}
          </button>
        }
        {footerTextElement}
        </div>
      </div>
    </div>
  )
}

QRCodeReceipt.defaultProps = {
  title: '',
  qrCodeData: '',
  menu: {},
  order: {},
  onDone: () => {},
  isRichCheckout: false
}

QRCodeReceipt.propTypes = {
  title: PropTypes.string,
  qrCodeData: PropTypes.string,
  menu: PropTypes.object,
  order: PropTypes.object,
  onDone: PropTypes.func,
  isRichCheckout: PropTypes.bool
}

export default QRCodeReceipt
